/**
 * Format a past timestamp as a Spanish relative-time string ("Hace 2 meses").
 * Returns "Hoy" for anything <24h ago. Use es-GT semantics so units match the
 * legacy CRM the user is migrating from ("hace X días/semanas/meses/años").
 */
export function formatRelativeEs(value: string | Date | null | undefined): string {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const diffMs = Date.now() - date.getTime();
  if (diffMs < 0) return 'Hoy';

  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 60) return minutes <= 1 ? 'Hace un momento' : `Hace ${minutes} min`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Hace ${hours} ${hours === 1 ? 'hora' : 'horas'}`;

  const days = Math.floor(hours / 24);
  if (days < 7) return `Hace ${days} ${days === 1 ? 'día' : 'días'}`;

  const weeks = Math.floor(days / 7);
  if (days < 30) return `Hace ${weeks} ${weeks === 1 ? 'semana' : 'semanas'}`;

  const months = Math.floor(days / 30);
  if (months < 12) return `Hace ${months} ${months === 1 ? 'mes' : 'meses'}`;

  const years = Math.floor(days / 365);
  return `Hace ${years} ${years === 1 ? 'año' : 'años'}`;
}
